// Entry point for the build script in your package.json

import './polyfills/process'

// Core JavaScript entry point for esbuild compilation
import Popper from '@popperjs/core/dist/umd/popper.min'
import * as bootstrap from 'bootstrap'
import Rails from '@rails/ujs'
import * as ActiveStorage from '@rails/activestorage'
import '@lottiefiles/lottie-player'
import '@hotwired/turbo-rails'
import RailsTimezone from 'rails-timezone'
import '../assets/javascript/controllers'
import { gaPurchase } from '../assets/javascript/components/shared/helpers/googleAnalytics'
import '../assets/javascript/channels'
import '../assets/javascript/scripts'

// Expose globals for backward compatibility
window.Popper = Popper
window.bootstrap = bootstrap
window.rails_timezone = RailsTimezone
window.gaPurchase = gaPurchase

// Initialize Rails UJS and ActiveStorage
Rails.start()
ActiveStorage.start()
